import Api from "./API";

const registerWorkerStripeAccount = async () => {
  const response = await Api.axios.post("payment/account");
  return response.data;
};

const getStripeConnectLoginLink = async () => {
  const response = await Api.axios.get("payment/account/stripe-connect/login-link");
  return response.data;
};

const createShiftStripePaymentLink = async (shiftId: string) => {
  const response = await Api.axios.post(`shift-payment/${shiftId}/stripe-payment-link`);
  return response.data;
};

export const PaymentService = {
  registerWorkerStripeAccount,
  getStripeConnectLoginLink,
  createShiftStripePaymentLink,
};
